// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YxRs","title":"Header_title__1NzsZ","side":"Header_side__3Mjb8"};